import { FC } from "react";
import Modal from "components/Modal";
import { useWhatsappPhone } from "../model/useWhatsappPhone";

import styles from "./WhatsappPhoneModal.module.css";

interface Props {
  onClose: () => void;
  // Уже отправленный номер (из профиля) — если есть, шаг ввода номера пропускаем
  // и сразу показываем статус "на рассмотрении", вместо повторного запроса номера.
  pendingPhoneMasked?: string | null;
}

export const WhatsappPhoneModal: FC<Props> = ({
  onClose,
  pendingPhoneMasked = null,
}) => {
  const {
    phone,
    setPhone,
    validationError,
    submit,
    isSubmitting,
    phoneMasked,
    apiError,
  } = useWhatsappPhone();

  const confirmedPhoneMasked = phoneMasked ?? pendingPhoneMasked;

  if (confirmedPhoneMasked) {
    return (
      <Modal isOpen onClose={onClose} title="WhatsApp 2FA">
        <div className={styles.content}>
          <p className={styles.status}>
            Phone number received: {confirmedPhoneMasked}. WhatsApp
            verification is being set up.
          </p>
          <button
            type="button"
            className={styles.submitButton}
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </Modal>
    );
  }

  return (
    <Modal isOpen onClose={onClose} title="Link WhatsApp">
      <form
        className={styles.content}
        onSubmit={(event) => {
          event.preventDefault();
          submit();
        }}
      >
        <p className={styles.hint}>
          Enter your phone number in international format. We&apos;ll use it
          to set up WhatsApp 2FA.
        </p>
        <input
          className={styles.input}
          type="tel"
          placeholder="+79001234567"
          value={phone}
          onChange={(event) => setPhone(event.target.value)}
          disabled={isSubmitting}
        />
        {(validationError || apiError) && (
          <p className={styles.error}>{validationError ?? apiError}</p>
        )}
        <button
          type="submit"
          className={styles.submitButton}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </form>
    </Modal>
  );
};
